import API from "API";
import React, { Fragment, useCallback, useEffect, useState } from "react";
import {
    Button,
    Col,
    Divider,
    Flex,
    Input,
    Pagination,
    Row,
    Select,
    Skeleton,
} from "antd";
import NewsFeed, { statusMapping } from "./NewsFeed";
import toastr from "toastr";
import ActionPostNewsFeed from "./ActionPostNewsFeed";
import { useSearchParams } from "react-router-dom";
import dayjs from "dayjs";
import PostNewsFeed from "./PostNewsFeed";
import { searchWithoutAccent } from "general_function";
const { Search } = Input;

function StudentPost() {
    const [searchParams, setSearchParams] = useSearchParams();
    const [loading, setLoading] = useState(true);
    const [loadingPost, setLoadingPost] = useState(false);
    const [visible, setVisible] = useState(false);
    const [totalItems, setTotalItems] = useState(0);
    const [searchValue, setSearchValue] = useState(() => ({
        course: +searchParams.get("course") || null,
        search: searchParams.get("search") || "",
        page: searchParams?.get("page") || 1,
        pageSize: searchParams?.get("pageSize") || 10,
        status: searchParams?.getAll("status").map((item) => +item) || [],
    }));
    const [dataPost, setDataPost] = useState([]);
    const optionStatus = statusMapping?.map(({ text, status }) => ({
        label: text,
        value: status,
    }));
    const handleOnClickButtonPost = useCallback(() => {
        if (!searchValue?.course) {
            toastr.warning("Vui lòng chọn môn học");
            return;
        }
        setVisible(true);
    }, [searchValue]);
    const handleCourseChange = useCallback((value) => {
        setSearchValue((prev) => ({
            ...prev,
            course: value,
        }));
    }, []);
    const handlePageChange = useCallback((page, pageSize) => {
        setSearchValue((prev) => ({
            ...prev,
            page: page,
            pageSize: pageSize,
        }));
    }, []);
    const [optionStudentCourse, setOptionStudentCourse] = useState([]);
    const [gettingStudentCourse, setGettingStudentCourse] = useState(true);
    const getDataStudentCourse = useCallback(async () => {
        try {
            const response = await API.get("/student/courses/", {
                params: {
                    page_size: 1000,
                },
            });
            const data = response.data.results;
            const dataStudentCourse = data?.map(({ name, id }) => ({
                label: name,
                value: id,
            }));
            setOptionStudentCourse(dataStudentCourse);
            setLoading(false);
        } catch (e) {
            console.log(e);
        } finally {
            setGettingStudentCourse(false);
        }
    }, []);

    const getDataPost = useCallback(async () => {
        try {
            if (!searchValue?.course) {
                toastr.warning("Vui lòng chọn môn học");
                return;
            }
            setLoadingPost(true);
            const params = {
                search: searchValue?.search,
                course: searchValue?.course,
                page: searchValue?.page,
                page_size: searchValue?.pageSize,
                status__in: searchValue.status.join(","),
            };

            const response = await API.get("/student/posts/", {
                params: params,
            });
            const data = response.data?.results?.map((item) => ({
                ...item,
                created_at: dayjs(item.created_at),
            }));
            setTotalItems(response.data?.count);
            setDataPost(data);
        } catch (error) {
            if (error?.response?.data?.error) {
                toastr.error(error?.response?.data?.error);
                return;
            }
        } finally {
            setLoadingPost(false);
        }
    }, [searchValue]);

    const handleSearch = useCallback(
        (value) => {
            if (!searchValue?.course) {
                toastr.warning("Vui lòng chọn môn học");
                return;
            }
            setSearchValue((prev) => {
                return { ...prev, search: value, page: 1 };
            });
        },
        [searchValue]
    );

    const handleChangeStatus = useCallback(
        (value) => {
            if (!searchValue?.course) {
                toastr.warning("Vui lòng chọn môn học");
                return;
            }
            setSearchValue((prev) => {
                return { ...prev, page: 1, status: value };
            });
        },
        [searchValue]
    );

    useEffect(() => {
        getDataStudentCourse();
    }, [getDataStudentCourse]);

    useEffect(() => {
        if (searchValue?.course) {
            getDataPost();
        }
    }, [searchValue, getDataPost]);

    useEffect(() => {
        setSearchParams((prev) => {
            const params = {
                search: searchValue?.search || "",
                page: searchValue?.page,
                pageSize: searchValue?.pageSize,
                status: searchValue?.status || [],
            };
            if (searchValue.course) {
                params.course = searchValue.course;
            }
            return params;
        });
    }, [searchValue, setSearchParams]);

    useEffect(() => {
        if (gettingStudentCourse) return;
        if (
            !optionStudentCourse.find(
                (item) => item.value === searchValue.course
            )
        ) {
            setSearchValue((prev) => ({
                ...prev,
                course: null,
            }));
        }
    }, [searchValue.course, gettingStudentCourse, optionStudentCourse]);

    return loading ? (
        <Skeleton active />
    ) : (
        <>
            <h5>Chọn môn học:</h5>

            <div>
                <Flex wrap gap="small">
                    <Select
                        style={{ width: "200px" }}
                        placeholder="Chọn môn học"
                        onChange={handleCourseChange}
                        value={searchValue.course}
                        options={optionStudentCourse}
                        filterSort={(optionA, optionB) =>
                            (optionA?.label ?? "")
                                .toLowerCase()
                                .localeCompare(
                                    (optionB?.label ?? "").toLowerCase()
                                )
                        }
                        filterOption={searchWithoutAccent}
                        showSearch
                        allowClear
                        onClear={() => {
                            setSearchValue({
                                search: "",
                                status: [],
                                page: 1,
                                pageSize: 10,
                                course: null,
                            });
                        }}
                    />
                </Flex>
            </div>

            <Divider />

            <div>
                <Button type="primary" onClick={handleOnClickButtonPost}>
                    Thêm bài viết
                </Button>

                <Row gutter={8}>
                    <Col
                        md={12}
                        lg={12}
                        sm={24}
                        span={12}
                        style={{ marginTop: 5 }}
                    >
                        <Search
                            placeholder={`Tìm kiếm bài viết...`}
                            onSearch={handleSearch}
                            loading={loadingPost}
                            disabled={loadingPost}
                            style={{ width: "100%" }}
                            allowClear
                        />
                    </Col>
                    <Col
                        md={12}
                        lg={12}
                        sm={24}
                        span={12}
                        style={{ marginTop: 5 }}
                    >
                        <Select
                            mode="multiple"
                            loading={loadingPost}
                            disabled={loadingPost}
                            value={searchValue.status}
                            onChange={handleChangeStatus}
                            placeholder="Chọn trạng thái"
                            style={{ width: "100%" }}
                            options={optionStatus}
                            allowClear
                        />
                    </Col>
                </Row>
            </div>

            {searchValue?.course && (
                <ActionPostNewsFeed
                    getDataPost={getDataPost}
                    visible={visible}
                    setVisible={setVisible}
                    id={searchValue?.course}
                    setLoadingPost={setLoadingPost}
                />
            )}
            {loadingPost ? (
                <Skeleton active />
            ) : (
                <div>
                    {!searchValue.course ? (
                        <div style={{ marginTop: 20, textAlign: "center" }}>
                            Vui lòng chọn môn học để hiển thị!
                        </div>
                    ) : dataPost?.length > 0 ? (
                        <>
                            {dataPost.map((post) => (
                                <Fragment key={`post-${post?.id}`}>
                                    <NewsFeed
                                        dataPost={post}
                                        getDataPost={getDataPost}
                                        setDataPost={setDataPost}
                                    />
                                </Fragment>
                            ))}
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    marginTop: 16,
                                }}
                            >
                                <Pagination
                                    current={searchValue?.page}
                                    pageSize={searchValue?.pageSize}
                                    total={totalItems}
                                    onChange={handlePageChange}
                                    showSizeChanger
                                />
                            </div>
                        </>
                    ) : (
                        <div style={{ marginTop: 20, textAlign: "center" }}>
                            Hiện chưa có bài viết nào!
                        </div>
                    )}
                </div>
            )}

            <PostNewsFeed />
        </>
    );
}

export default StudentPost;
